<template>
    <div>
        <el-time-select
            placeholder="起始时间"
            class="time-select-range-start"
            :value="startTime"
            :disabled="props.disabled"
            :picker-options="{ ...props.startOptions, maxTime: endTime }"
            @input="startChange"
        />
        <el-time-select
            placeholder="结束时间"
            :value="endTime"
            :disabled="props.disabled"
            :picker-options="{ ...props.endOptions, minTime: startTime }"
            @input="endChange"
        />
    </div>
</template>

<script>
export default {
    name: "TimeSelectRange",
    props: ["value", "widget", "verifyInfo", "rules"],
    computed: {
        props() {
            return this.widget.props;
        },
        startTime() {
            return (this.value || "").split("-")[0] || "";
        },
        endTime() {
            return (this.value || "").split("-")[1] || "";
        }
    },
    methods: {
        startChange(newVal) {
            const newValue = newVal || "";
            this.$emit("change", `${newValue}-${this.endTime}`);
            this.verifyHandler(newValue, this.endTime);
        },
        endChange(newVal) {
            const newValue = newVal || "";
            this.$emit("change", `${this.startTime}-${newValue}`);
            this.verifyHandler(this.startTime, newValue);
        },
        verifyHandler(start = "", end = "") {
            if (!this.rules.some(rule => rule.required)) {
                return;
            }

            const verifyInfo = start !== "" && end !== "" ? { isValid: true, message: "" } : { isValid: false, message: "请输入必要内容" };
            this.$emit("verify", verifyInfo);
        }
    }
};
</script>

<style lang="less" scoped>
.time-select-range-start {
    margin-right: 10px;
}
/deep/ .el-input__icon {
    line-height: 33px;
}
</style>
